<template>
    <div class="ale">
        <div class="ale-grid">
            <ApiLimitField v-for="f in limitFields" :key="f.key" :label="f.label" :hint="f.hint"
                :unlimited-label="f.unlimitedLabel" :placeholder="f.placeholder" :allow-inherit="allowInherit"
                :model-value="modelValue.limits[f.key]" @update:modelValue="v => setLimit(f.key, v)" />
        </div>

        <ApiPortalField :model-value="modelValue.allowed_portals" :portals="portals" :allow-inherit="allowInherit"
            @update:modelValue="setPortals" />

        <div class="ale-features">
            <span class="ak-label">Features</span>
            <div class="ale-feature-list">
                <div v-for="f in featureFlags" :key="f.key" class="ale-feature">
                    <template v-if="allowInherit">
                        <span class="ale-feature-name">{{ f.label }}</span>
                        <select class="ak-input ale-select" :value="modelValue.features[f.key]"
                            @change="setFeature(f.key, $event.target.value)">
                            <option value="inherit">Inherit</option>
                            <option value="on">On</option>
                            <option value="off">Off</option>
                        </select>
                    </template>
                    <label v-else class="ak-check">
                        <input type="checkbox" :checked="modelValue.features[f.key] === 'on'"
                            @change="setFeature(f.key, $event.target.checked ? 'on' : 'off')">
                        {{ f.label }}
                    </label>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ApiLimitField from './ApiLimitField.vue';
import ApiPortalField from './ApiPortalField.vue';
import { LIMIT_FIELDS, FEATURE_FLAGS } from './apiKeysCommon';

export default {
    name: 'ApiLimitsEditor',
    components: { ApiLimitField, ApiPortalField },
    props: {
        modelValue: { type: Object, required: true },
        portals: { type: Array, default: () => [] },
        allowInherit: { type: Boolean, default: false },
    },
    emits: ['update:modelValue'],
    data() {
        return { limitFields: LIMIT_FIELDS, featureFlags: FEATURE_FLAGS };
    },
    methods: {
        setLimit(key, v) {
            this.$emit('update:modelValue', { ...this.modelValue, limits: { ...this.modelValue.limits, [key]: v } });
        },
        setPortals(v) {
            this.$emit('update:modelValue', { ...this.modelValue, allowed_portals: v });
        },
        setFeature(key, v) {
            this.$emit('update:modelValue', { ...this.modelValue, features: { ...this.modelValue.features, [key]: v } });
        },
    },
};
</script>

<style scoped>
.ale { display: flex; flex-direction: column; gap: 1.1rem; }
.ale-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 1rem; }
.ale-features { display: flex; flex-direction: column; gap: 0.5rem; }
.ale-feature-list { display: grid; grid-template-columns: 1fr 1fr; gap: 0.5rem; }
.ale-feature {
    display: flex; align-items: center; justify-content: space-between; gap: 0.5rem;
    background: #f8fafc; border: 1px solid #e2e8f0; border-radius: 10px; padding: 0.5rem 0.8rem;
}
.ale-feature-name { font-size: 0.82rem; font-weight: 600; color: var(--text-primary); }
.ale-select { width: auto; padding: 0.35rem 0.6rem; font-size: 0.8rem; border-radius: 8px; }
@media (max-width: 640px) {
    .ale-grid, .ale-feature-list { grid-template-columns: 1fr; }
}
</style>
